/* BECAY - pellizcar para ampliar la foto de producto, DENTRO de su recuadro.
   Solo en pantallas tactiles. Con DOS dedos sobre una foto de la galeria, la
   propia imagen se amplia y se mueve dentro de su marco (que la recorta),
   anclada al punto entre los dedos; al soltar vuelve sola a su sitio.

   NADA de esto entorpece el deslizamiento con UN dedo, y ese es el motivo de
   como esta escrito:
   - Mientras no hay pellizco, aqui NO existe ninguna escucha de `touchmove`.
     Una escucha de touchmove no pasiva obliga al navegador a consultar al JS
     antes de mover un solo pixel, y eso vuelve pastoso el deslizamiento de
     todo el carrusel. La escucha se ANADE al empezar el pellizco y se QUITA
     al soltar, asi que en el uso normal el carrusel corre por la via rapida
     del compositor, exactamente igual que si este archivo no existiera.
   - La escucha de `touchstart` es PASIVA: no puede frenar el gesto, solo
     mira si han bajado dos dedos. Con uno, sale sin hacer nada.
   - Del zoom de pagina se encarga el CSS (`touch-action: pan-x pan-y` sobre
     la foto), que es declarativo y no cuesta un solo fotograma.

   El tope de ampliacion sale del ajuste "allow-zoom" de <product-gallery>:
   se cambia desde el editor y no hay ningun numero escrito aqui.

   El tema traia ademas su propio gesto (al pellizcar abria PhotoSwipe a
   pantalla completa en cuanto la escala pasaba de 1.5) con las escuchas en el
   <scroll-carousel> de dentro; las de aqui van en CAPTURA sobre
   <product-gallery> y cortan la propagacion, asi que ese visor ya no se abre
   en tactil. En escritorio no cambia nada: alli se abre al hacer clic.

   Se transforma la imagen REAL en su sitio: sin clon, sin capa nueva por
   encima del header y sin velo. La maquetacion no se entera y hay muchas
   menos piezas que puedan parpadear. El recorte lo pone el CSS (overflow en
   .product-gallery__media), por eso la foto crece sin salirse del recuadro. */
(function () {
  'use strict';

  if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return;
  var galleries = document.querySelectorAll('product-gallery');
  if (!galleries.length) return;

  document.documentElement.classList.add('bcy-pinch');

  var state = null;
  var MOVE_OPTIONS = { capture: true, passive: false };

  function distance(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function middle(touches) {
    return {
      x: (touches[0].clientX + touches[1].clientX) / 2,
      y: (touches[0].clientY + touches[1].clientY) / 2,
    };
  }

  function onMove(event) {
    if (!state) return;
    if (event.touches.length !== 2) return;
    /* Cancela el desplazamiento del carrusel mientras dura el pellizco. Al
       registrarse en el touchstart, llega a tiempo del primer touchmove. */
    event.preventDefault();
    event.stopPropagation();
    var scale = distance(event.touches) / state.startDistance;
    if (scale < 1) scale = 1;
    if (scale > state.max) scale = state.max;
    var point = middle(event.touches);
    var x = point.x - state.startMiddle.x;
    var y = point.y - state.startMiddle.y;
    state.image.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ')';
  }

  function onRelease(event) {
    if (state && event.touches.length < 2) end();
  }

  function listen(on) {
    var method = on ? 'addEventListener' : 'removeEventListener';
    document[method]('touchmove', onMove, MOVE_OPTIONS);
    document[method]('touchend', onRelease, true);
    document[method]('touchcancel', onRelease, true);
  }

  function start(event, image, max) {
    var rect = image.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var point = middle(event.touches);

    /* Se pide al srcset una resolucion acorde al zoom maximo para que
       ampliada no se vea blanda. Una sola vez por imagen: hasta que llega la
       mayor se sigue viendo la que ya estaba descargada, sin ningun hueco. */
    if (image.getAttribute('srcset') && !image.dataset.bcyPinchSized) {
      image.dataset.bcyPinchSized = '1';
      image.setAttribute('sizes', Math.round(rect.width * max) + 'px');
    }

    image.style.transition = 'none';
    image.style.willChange = 'transform';
    /* El zoom se ancla donde estan los dedos, en coordenadas de la imagen:
       con el origen en el centro, la foto se desplazaba respecto a los dedos
       y parecia que patinaba. */
    image.style.transformOrigin = point.x - rect.left + 'px ' + (point.y - rect.top) + 'px';

    state = {
      image: image,
      startDistance: distance(event.touches),
      startMiddle: point,
      max: max,
    };
    listen(true);
  }

  function end() {
    if (!state) return;
    var image = state.image;
    state = null;
    listen(false);

    var done = false;
    var clean = function () {
      if (done) return;
      done = true;
      image.removeEventListener('transitionend', clean);
      image.style.transition = '';
      image.style.transform = '';
      image.style.transformOrigin = '';
      image.style.willChange = '';
    };

    /* La vuelta se anima y las propiedades solo se limpian al terminarla; con
       un temporizador podia caer un fotograma antes y se veia un salto. */
    image.addEventListener('transitionend', clean);
    requestAnimationFrame(function () {
      image.style.transition = 'transform 0.32s cubic-bezier(0.32, 0.72, 0, 1)';
      image.style.transform = 'translate3d(0px, 0px, 0) scale(1)';
    });
    /* Red de seguridad por si el navegador no emite transitionend. */
    setTimeout(clean, 600);
  }

  Array.prototype.forEach.call(galleries, function (gallery) {
    var max = parseFloat(gallery.getAttribute('allow-zoom'));
    if (!max || max <= 1) max = 3;

    gallery.addEventListener(
      'touchstart',
      function (event) {
        if (state || event.touches.length !== 2) return;
        var media = event.target.closest ? event.target.closest('.product-gallery__media') : null;
        if (!media || (media.dataset.mediaType && media.dataset.mediaType !== 'image')) return;
        var image = media.querySelector('img');
        if (!image) return;
        /* Pasiva: no se llama a preventDefault. Solo se corta la propagacion
           para que el carrusel no vea el segundo dedo. */
        event.stopPropagation();
        start(event, image, max);
      },
      { capture: true, passive: true }
    );

    /* Safari de iOS tiene ademas sus propios eventos de gesto. Solo se emiten
       con varios dedos, asi que no afectan al deslizamiento normal. */
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (name) {
      gallery.addEventListener(
        name,
        function (event) {
          event.preventDefault();
          event.stopPropagation();
        },
        { capture: true, passive: false }
      );
    });
  });
})();